import _ from 'lodash';

module.exports.addCorporationToPath = function(path, corporation) {
	let newBreadcrumb = { url: '/' + corporation.rawId, label: corporation.name };
	if (!_.includes(path, newBreadcrumb)) {
		path = _.concat(path, newBreadcrumb);
	}
	return path;
};

module.exports.addBuilderToPath = function(path, builder) {
	let newBreadcrumb = { url: '/' + 'builders/' + builder.id, label: builder.name };
	if (!_.includes(path, newBreadcrumb)) {
		path = _.concat(path, newBreadcrumb);
	}
	return path;
};

module.exports.addSubdivisionToPath = function(path, subdivision) {
	let newBreadcrumb = { url: '/subdivisions/' + subdivision.id, label: subdivision.name };
	if (!_.includes(path, newBreadcrumb)) {
		path = _.concat(path, newBreadcrumb);
	}
	return path;
};

module.exports.addFeedToPath = function(path, feed) {
	let newBreadcrumb = { url: '/' + feed.rawId, label: feed.name };
	if (!_.includes(path, newBreadcrumb)) {
		path = _.concat(path, newBreadcrumb);
	}
	return path;
};



// WEBPACK FOOTER //
// ./src/assets/js/lib/breadcrumb-lib.js